// CSV keeps older comma-separated saved searches compatible, while allowing
// Enter-selected phrases containing commas to remain a single search term.
export function parseKeywordTerms(value = '') {
  const terms = [];
  let term = '', quoted = false;
  for (let i = 0; i < value.length; i += 1) {
    const char = value[i];
    if (char === '"') {
      if (quoted && value[i + 1] === '"') { term += '"'; i += 1; }
      else quoted = !quoted;
    } else if (char === ',' && !quoted) { if (term.trim()) terms.push(term.trim()); term = ''; }
    else term += char;
  }
  if (term.trim()) terms.push(term.trim());
  return terms;
}

export const formatKeywordTerms = terms => terms.map(term => /[,"\r\n]/.test(term) ? `"${term.replace(/"/g, '""')}"` : term).join(', ');
